var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asc-dialog',{attrs:{"text":_vm.title,"show-dialog":_vm.showDialog,"on-close":_vm.handleClose,"width":1000}},[(_vm.showDialog)?[_c('asc-raw-report',{attrs:{"report-text":_vm.reportText,"loading":_vm.loading}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }